/** A warm, time-of-day greeting for the logged-in user (first name only). */
export function greeting(name: string | undefined, now: Date = new Date()): string {
  const first = (name ?? '').trim().split(/\s+/)[0] || 'der';
  const h = now.getHours();
  const time = h < 10 ? 'God morgen' : h < 12 ? 'God formiddag' : h < 18 ? 'God eftermiddag' : 'God aften';
  return `${time}, ${first}`;
}
